import './base.css';
import './design.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import './foundation.css';
import { createApp, defineAsyncComponent, h } from 'vue';
import { createStore } from 'vuex';
import * as Sentry from '@sentry/vue';
import dashboardStore from '../sections/dashboard/store';
import adminStore from '../sections/admin/store';
import adminRoutes from '../sections/admin/routes';
import dashboardRoutes from '../sections/dashboard/routes';
import settingsRoutes from './settings/routes';
import selectDestination from './destination';
import { createDestinationRouter } from './router';
import register from './register';
import { createNotifications } from './notifications';
import Notifications from './Notifications.vue';
import createSession from './session';
import expiresSession from './authenticationFailure';
import axios from 'axios';
import Application from './Application.vue';
import ErrorExperience from './ErrorExperience.vue';
import Authentication from './Authentication.vue';
import Recovery from './Recovery.vue';

const destination = selectDestination(location.pathname, !!document.getElementById('application-error'));
const routeGroups = {
  dashboard: dashboardRoutes, admin: adminRoutes, settings: settingsRoutes,
  brew_tools: [{ path: '/:pathMatch(.*)*', component: () => import('./BrewTools.vue') }],
  shared_brew: [{ path: '/:pathMatch(.*)*', component: () => import('./SharedBrew.vue') }],
  brew_editor: [{ path: '/:pathMatch(.*)*', component: () => import('./BrewEditor.vue') }],
  owner_brew: [{ path: '/:pathMatch(.*)*', component: () => import('./OwnerBrew.vue') }]
};
const roots = { application: Application, error: ErrorExperience, public: defineAsyncComponent(() => import('./publicPages/PublicPages.vue')), recovery: Recovery, authentication: Authentication };
const props = { application: { sessionRequired: destination.session === 'required' }, public: { page: destination.page, loadSession: destination.session === 'optional' } };
const store = createStore(({ admin: adminStore, dashboard: dashboardStore })[destination.store]);
const router = createDestinationRouter(destination, routeGroups[destination.routes].concat([{ path: '/:pathMatch(.*)*', component: () => import('./ErrorExperience.vue') }]));
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
store.registerModule('session', createSession(async () => {
  const result = await axios.get('/application/session');
  store.commit('SET_SESSION_USER', result.data);
  return result.data;
}));
axios.interceptors.response.use(response => response, error => {
  if (expiresSession(error)) store.commit('session/failed', true);
  return Promise.reject(error);
});
const notifications = createNotifications();
const app = createApp({ render: () => [h(roots[destination.root], props[destination.root] || {}), h(Notifications, { service: notifications })] });
app.use(store).use(router);
register(app);
app.use(notifications);
if (import.meta.env.PROD) Sentry.init({ app, dsn: 'https://76a9949b83ce46d1a6d7511013da474c@sentry.io/134478' });
router.isReady().then(() => app.mount('#vueapp'));
window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
